// extracted by mini-css-extract-plugin
module.exports = {"fastStartsGrid":"velocity-page_fastStartsGrid__IWzeJ"};